import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaUserCircle } from 'react-icons/fa';
import backgroundDetailContact from '../../assets/backgroundDetailContact.svg';
import backgroundDetailContactMobile from '../../assets/backgroundDetailContactMobile.svg';
import iconProfileCIrcle from '../../assets/iconProfileCIrcle.svg';
import iconEditContact from '../../assets/iconEditContact.svg';
import calendarAddIcon from "../../assets/calendarAddIcon.svg"
import ModalCalendario from "./ModalCalendario.jsx";
import iconCopy from "../../assets/iconCopy.svg";
import { updateContactById, getAsesorById } from "../../../../endpoints.js"
import { copyToClipboard } from "../../../../Utils/index.js"
import HistoricoComunicacion from "../../../../Components/Contacts/HistoricoComunicacion.jsx"
import { useWindowWidth } from "@react-hook/window-size";

const DetailContact =
  ({
    contact,
    setSelectContact,
    user,
    formData,
    setFormData,
    selectedContact,
    handlerOpenModal,
    handlerOpenModalObservaciones,
    openModal,
    openModalObservaciones,
    closeModal,
    closeModalObservaciones,
    setSeActualizoContacto,
    getContacts,
    getContactID,
    setContacts,
    statusContact,
    setRefresh,
    scrollContainerRef
  }) => {
    const onlyWidth = useWindowWidth();
    const handlePhotoChange = (e) => {
      const file = e.target.files[0];
      setFormData({
        ...formData,
        photo: file,
      });
    };
    function convertirFecha(fechaString) {
      const fecha = new Date(fechaString);
      const dia = fecha.getDate();
      const mes = fecha.getMonth() + 1; // Los meses comienzan desde 0, por lo que se suma 1
      const año = fecha.getFullYear();
      const hora = fecha.getHours();
      const minutos = fecha.getMinutes();

      // Formatear los componentes de la fecha/hora para que tengan dos dígitos
      const diaFormateado = dia < 10 ? '0' + dia : dia;
      const mesFormateado = mes < 10 ? '0' + mes : mes;
      const horaFormateada = hora < 10 ? '0' + hora : hora;
      const minutosFormateados = minutos < 10 ? '0' + minutos : minutos;

      // Construir la cadena de fecha en el formato deseado
      const fechaFormateada =
        `${horaFormateada}:${minutosFormateados}hs - ${diaFormateado}/${mesFormateado}/${año}`;

      return fechaFormateada;
    }
    const [errors, setErrors] = useState({
      photo: '',
      name: '',
      lastname: '',
      phone: '',
      email: '',
      password: '',
    });

    const handleFormClick = (e) => {
      e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
    };

    console.log(selectedContact)
    const copyPhone = (data) => copyToClipboard(data);
    return (
      <DivBoxContainer>
        {
          openModal ?
            <ModalCalendario
            user={user}
              contacto={selectedContact}
              onClose={closeModal}
              updateContactById={updateContactById}
              stopPropagation={handleFormClick}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              setContacts={setContacts}
              scrollContainerRef={scrollContainerRef}
              statusContactFilter={statusContact}
              setRefresh={setRefresh}
            />
            : null
        }

        <DivContainer>

          <DivContentImage src={ onlyWidth > 1100 ? backgroundDetailContact: backgroundDetailContactMobile} />
          {
            selectedContact?.User?.name ? 
            <DivAsignadoText>
              Asignado: {selectedContact?.User?.name + " " + selectedContact?.User?.lastname }
              </DivAsignadoText>
            :
            <DivAsignadoText style={{
              backgroundColor:"#c8c7c9"
            }}>Sin asignar</DivAsignadoText>
       
          }

         {
             user.type !== "Admin" || user.type !== "Supervisor" ? 
             null:
             <ContainerBtnEditar src={iconEditContact} />
         }
 
          <DivColumnRelative>
            <ImageProfile src={selectedContact?.image || iconProfileCIrcle} />
            <TextNameUser><b>{selectedContact?.name} {selectedContact?.lastname}</b></TextNameUser>

          </DivColumnRelative>

        </DivContainer>

        <DivColumn1>
          <DivRow1>
            <Text1 style={{
              fontSize: '16px',
              margin: '0px 0px 8px 0px',
              color: selectedContact?.status === "Contactado" ? '#35a12c' : 
                     selectedContact?.status === "En Seguimiento" ? '#f5c54b' : 
                     selectedContact?.status === "No Contactado" ? '#c8c7c7' : 
                     selectedContact?.status === "Sin Respuesta" ? '#780000': '#c8c7c7',
              width: '190px',
              flexDirection: 'row',
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              justifyContent: 'flex-end'

            }}><b>{selectedContact?.status}</b>


            </Text1>
            <BotonCalendar
              onClick={() => handlerOpenModal()}
            >

              <CalendarIconImg src={calendarAddIcon} />
            </BotonCalendar>
          </DivRow1>

          <Text1 style={{
            fontSize: '16px',
            margin: '0px 0px 8px 0px'
          }}><b>Datos de contacto</b></Text1>
          <Text1><b>Teléfono: </b>
            <a
              href={`https://api.whatsapp.com/send/?phone=${selectedContact?.phone}&app_absent=0`}
              target='_blank'
            >
              {selectedContact?.phone}
            </a>
            <dfn data-info="Copiar" class="tooltip-container" >
              <CopyBtn src={iconCopy} onClick={() => copyPhone(selectedContact?.phone)} />
              <span class="tooltip-text">Copiar</span>
            </dfn>
          </Text1>
          <Text1><b>Teléfono2: </b>
            <a
              href={`https://api.whatsapp.com/send/?phone=${selectedContact?.phone2}&app_absent=0`}
              target='_blank'
            >
              {selectedContact.phone2}
            </a>
            <dfn data-info="Copiar" class="tooltip-container" >
              <CopyBtn src={iconCopy} onClick={() => copyPhone(selectedContact?.phone2)} />
              <span class="tooltip-text">Copiar</span>
            </dfn>
          </Text1>
          <Text1><b>Teléfono3: </b>
            <a
              href={`https://api.whatsapp.com/send/?phone=${selectedContact?.phone3}&app_absent=0`}
              target='_blank' >
              {selectedContact.phone3}
            </a>
            <dfn data-info="Copiar" class="tooltip-container" >
              <CopyBtn src={iconCopy} onClick={() => copyPhone(selectedContact?.phone3)} />
              <span class="tooltip-text">Copiar</span>
            </dfn>

          </Text1>

          <Text1><b>Email:</b> {selectedContact?.email}</Text1>
          <Text1><b>Origen:</b> {selectedContact?.origen}</Text1>
          <Text1><b>Via de contacto:</b> {selectedContact?.viaDeContacto}</Text1>
          <HistoricoComunicacion
        getAsesorById={getAsesorById}
          observations={selectedContact?.Observaciones}
          convertirFecha={convertirFecha} 
          />
      
        </DivColumn1>

      </DivBoxContainer>

    );
  };

export default DetailContact;
const CalendarIconImg = styled.img`
  max-width:24px;
  max-height:28px;
  width:24px;
  height:28px;
  
`;
const CopyBtn = styled.img`
  max-width:16px;
  max-height:16px;
  width:16px;
  height:16px;
  margin: 0px 5px;
  cursor: pointer;
  &:hover{
    opacity:0.7;
  }
  &:active{
    zoom:0.9
  }
`;
const BtnIcon = styled.div`
border-radius: 20%;
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .5) 0 1px 1px;
    cursor: pointer;
    height: 25px;
    margin: 0px 0px 0px 0px;
    align-self: end;
    align-content: center;
    width: 20px;
    gap: 8px;
    font-family: 'Montserrat',sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #07082c;
    padding: 4px 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  
  &:focus {
    // border-color: #380418;
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.9);
    // transform:scale(0.90)
  }
  &:active {
  
    transform:scale(0.95)
  }
`;

const BotonCalendar = styled.div`
border-radius: 100%;
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
    cursor: pointer;
    height: 30px;
    margin: 0px 0px 0px 0px;
    align-self: end;
    align-content: center;
    width: 25px;
    gap: 8px;
    font-family: 'Montserrat',sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #07082c;
    padding: 4px 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  
  &:focus {
    // border-color: #380418;
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.5);
    // transform:scale(0.90)
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  }
  &:active {
    // transition: all 0.1s linear;
    // filter: opacity(0.9);
    transform:scale(0.90)
  }
`;
const DivBoxContainer = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
width: -webkit-fill-available;
height: auto;
`;

const ContainerBtnEditar = styled.img`
position: relative;
height: 25px;
font-family: 'Montserrat',sans-serif;
font-weight: 500;
font-size: 16px;
color: #FFFFFF;
background-color: #00000054;
left: unset;
padding: 5px;
top: -175px;
margin-right: 16px;
margin-left: 93%;
width: -webkit-fill-available;
border-radius: 4px;
filter: drop-shadow(0.2px 0.2px 0px #00000099);
text-align: center;
}

`;

const DivAsignadoText = styled.div`
position: relative;

height: auto;
font-family: 'Montserrat',sans-serif;
font-weight: 500;
font-size: 16px;
color: #FFFFFF;
background-color: #00000099;
left: unset;
padding: 5px;
margin-right: 16px;
margin-left: 80%;
width: -webkit-fill-available;
top: -40px;
border-radius: 4px;
filter: drop-shadow(0.2px 0.2px 0px #c40000);
text-align: center;
@media only screen and (min-width:0px) and (max-width:1100px){
  top: -130px;
  // width:80vw;
  margin: 0px 16px;
  font-size: 12px;
}
`;

const TextNameUser = styled.span`
width: auto;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #003049;

`;

const DivRow1 = styled.div`
display:flex;
flex-direction:row;
align-items:flex-end;
justify-content:flex-end;
width: -webkit-fill-available;
// border:solid 1px red;
gap:5px;

`;

const DivRow2 = styled.div`
display:flex;
flex-direction:row;
align-items:flex-start;
justify-content:space-between;
gap:32px;
// border:solid 1px red;
width: auto;

`;

const DivColumn2 = styled.div`
display:flex;
flex-direction:column;
align-items:flex-start;
justify-content:flex-start;

// border:solid 1px red;
width: auto;

`;


const DivColumn1 = styled.div`
display:flex;
flex-direction:column;
align-items:flex-start;
justify-content:center;
width: -webkit-fill-available;
margin: 65px 0% 0% 0%;
padding: 16px 16px;
border-radius:8px;
gap:5px;
background-color:#FFFFFF;
box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

const DivColumnRelative = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
position: relative;
width: auto;
z-index: 2;
top: -80px;
align-self: flex-start;
margin-left: 16px;
@media only screen and (min-width:1100px) and (max-width:1380px) {
  zoom:0.85
  }
  @media only screen and (min-width:0px) and (max-width:1100px) {
    margin-left: 0px;
    align-self: center;
    zoom:0.85
    }
`;

const DivContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: flex-start;
width: -webkit-fill-available;
// border: solid 1px red;
height: 180px;
max-height: 180px;
margin: 0px 0%
gap:0px;

`;

const DivContentImage = styled.img`
height: 150px;
width: 100%;
background-color: #FFFFFF;
object-fit: cover;
border-radius: 8px 8px 8px 8px;
box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

const ImageProfile = styled.img`

height: 100px;
width: 100px;
background-color: #FFFFFF;
object-fit: cover;
border-radius: 100%;
filter: drop-shadow(2px 4px 6px #cecece);

`;


const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: 800;
  font-size: 14px;
  color: #07082c;
`;

const AvatarInputContainer = styled.label`
  position: relative;
  width: 3vw; /* Tamaño del avatar en relación con el ancho de la pantalla */
  height: 3vw; /* Tamaño del avatar en relación con el ancho de la pantalla */
  max-width: 100px; /* Máximo tamaño del avatar */
  max-height: 100px; /* Máximo tamaño del avatar */
  border-radius: 50%;
  border: 2px dashed #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const NoPhotoIcon = styled(FaUserCircle)`
  width: 3vw; /* Tamaño del icono en relación con el ancho de la pantalla */
  height: 3vw; /* Tamaño del icono en relación con el ancho de la pantalla */
//   max-width: 35px; /* Máximo tamaño del icono */
//   max-height: 35px; /* Máximo tamaño del icono */
  color: #ccc;
`;

const ErrorMessage = styled.div`
  color: red;
`;

const Text1 = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 13px;
color: #003049;
display: flex;
flex-direction: row;
align-content: center;
align-items: center;
justify-content: flex-start;
gap: 3px;
height:18px;


`;